import api from "./api";

// Capa de servicios API del dominio "messaging" (plantillas de difusión / broadcast templates)
// (FSD / capa API transversal). Wrappers de transporte finos.

export const listBroadcastTemplates = (params) =>
  api.get("/messaging/broadcast-templates", { params });
export const createBroadcastTemplate = (payload) =>
  api.post("/messaging/broadcast-templates", payload);
export const updateBroadcastTemplate = (templateId, payload) =>
  api.put(`/messaging/broadcast-templates/${templateId}`, payload);
export const deleteBroadcastTemplate = (templateId) =>
  api.delete(`/messaging/broadcast-templates/${templateId}`);
export const getBroadcastSpintaxPreview = (payload) =>
  api.post("/messaging/broadcast-templates/spintax-preview", payload);
